// extracted by mini-css-extract-plugin
module.exports = {"root":"Details_root__dq_PJ","image":"Details_image__kCDRH","slider__left-value":"Details_slider__left-value__j83bo","slider__right-value":"Details_slider__right-value__2REVX"};